import React from 'react';

import './Form.css';
import StudentForm from './Components/Student/StudentForm';
import HousingForm from './Components/Housing/HousingForm';
import AdditionalForm from './Components/Additional/AdditionalForm';
import FinancialForm from './Components/Financial/FinancialForm';


export default function Form (props) {

  const { student, house_meal, finance, additional } = props.data

  return (
    <div>
      <StudentForm data={student} changeState={(newState) => props.changeState("student", newState)} invalid={props.invalid.includes("student")} />
      <hr></hr>
      <HousingForm data={house_meal} student={student} changeState={(newState) => props.changeState("house_meal", newState)} invalid={props.invalid.includes("house_meal")} />
      <hr></hr>
      <AdditionalForm data={additional} student={student} changeState={(newState) => props.changeState("additional", newState)} invalid={props.invalid.includes("additional")} />
      <hr></hr>
      <FinancialForm data={finance} changeState={(newState) => props.changeState("finance", newState)} invalid={props.invalid.includes("finance")} />
      <div style={{textAlign: 'center', padding: 20}}>  
        <button className="hoverable" onClick={props.onSubmit}>ESTIMATE</button>
      </div>
    </div>
  )
}
